// Canonical CS-analysis date format: dd-mmm-yy (month as text), e.g. 03-Jul-26.
// Replaces toLocaleDateString() (which renders mm/dd/yyyy in the US locale) so
// dates read unambiguously across the CSP surfaces.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const format_date_dd_mmm_yy = (date) => {
    if (date === null || date === undefined || date === '') return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const dd = String(d.getDate()).padStart(2, '0');
    const mmm = MONTHS[d.getMonth()];
    const yy = String(d.getFullYear()).slice(-2);
    return `${dd}-${mmm}-${yy}`;
};

// Same date format plus 24h time, e.g. 03-Jul-26 14:07. Used where a full
// timestamp was previously shown via toLocaleString() (triage/history/evidence).
export const format_datetime_dd_mmm_yy = (date) => {
    if (date === null || date === undefined || date === '') return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${format_date_dd_mmm_yy(d)} ${hh}:${min}`;
};

export default format_date_dd_mmm_yy;
